export type RangeMode = "WEEK" | "MONTH" | "AGENDA";

const rangeModeStorageKeyPrefix = "fulling.googleCalendar.rangeMode.";

export function getPreferredCalendarRangeMode(scope: string): RangeMode {
  if (typeof window === "undefined") return "MONTH";
  const value = window.localStorage.getItem(`${rangeModeStorageKeyPrefix}${scope}`);
  return value === "WEEK" || value === "AGENDA" || value === "MONTH" ? value : "MONTH";
}

export function setPreferredCalendarRangeMode(scope: string, mode: RangeMode) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(`${rangeModeStorageKeyPrefix}${scope}`, mode);
}

/** 組出 Google 日曆「嵌入這個日曆」的 iframe 網址，支援同時疊多個日曆（合併顯示用）。 */
export function buildCalendarEmbedUrl(calendarIds: string[], mode: RangeMode = "MONTH") {
  const params = new URLSearchParams();
  params.set("ctz", "Asia/Taipei");
  params.set("mode", mode);
  params.set("showTitle", "0");
  params.set("showPrint", "0");
  params.set("showTabs", "0");
  params.set("showCalendars", "0");
  params.set("showTz", "0");
  let url = `https://calendar.google.com/calendar/embed?${params.toString()}`;
  calendarIds.forEach((id) => {
    const trimmed = id.trim();
    if (trimmed) url += `&src=${encodeURIComponent(trimmed)}`;
  });
  return url;
}
